import type React from 'react';
import { TextLink } from '@itandi/itandi-bb-ui';
import type { Deal } from '~/models/Deal';
import Styles from './ProductLinkList.module.scss';

type Props = {
  deal: Deal;
};

export const ProductLinkList: React.FC<Props> = ({ deal }: Props) => {
  if (deal.propertyType === null && deal.leasingId === null) {
    return null;
  }
  return (
    <div className={Styles.List}>
      {deal.propertyType === 'room' && (
        <TextLink
          color="link"
          href={`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_BKK}/rent_rooms/${deal.propertyId}/edit`}
          target="_blank"
        >
          物件システム
        </TextLink>
      )}
      {deal.propertyType === 'building' && (
        <TextLink
          color="link"
          href={`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_BKK}/rent_room_buildings/${deal.propertyId}/edit`}
          target="_blank"
        >
          物件システム
        </TextLink>
      )}
      {deal.leasingId !== null && (
        <TextLink
          color="link"
          href={`${process.env.NEXT_PUBLIC_ITANDIBB_SERVICES_KT}/leasings/${deal.leasingId}`}
          target="_blank"
        >
          入居者システム
        </TextLink>
      )}
    </div>
  );
};
